import type React from 'react';
import { useContext } from 'react';
import CreatePlayListContext from 'src/context/CreatePlayListContext';
import PlaylistItemRow from 'src/HomePage/DrawerAndPushedContents/RightSideDrawer/PlaylistItemRow';

const DRAG_TYPE = 'NEW_PLAYLIST_DRAG';

interface NewCollectionItemProps {
  id: string;
  name?: string;
  index: number;
  mediatype?: string;
  hoverCard: (fromIndex: number, toIndex: number) => void;
  moveCard: (id: string, toIndex: number) => void;
  flashId?: string | null;
}

const NewCollectionItem: React.FC<NewCollectionItemProps> = ({
  id,
  name,
  index,
  mediatype,
  hoverCard,
  moveCard,
  flashId,
}) => {
  const { setCreateAddedAssets } = useContext(CreatePlayListContext);

  const handleRemove = (): void => {
    setCreateAddedAssets((ids) => ids.filter((asset) => asset.id !== id));
  };

  return (
    <PlaylistItemRow
      id={id}
      name={name}
      index={index}
      mediatype={mediatype}
      dragType={DRAG_TYPE}
      onRemove={handleRemove}
      hoverCard={hoverCard}
      moveCard={moveCard}
      flashId={flashId}
    />
  );
};

export default NewCollectionItem;
